import React from 'react';
import {MUIAvatar, MUIBox, MUITypography} from '@/components/MUI-Components';
import {GoogleSourceCta} from '@/components/shared/icons/SocialIcons';

const BlogAuthorBar = ({authorInfo, reviewerInfo}: {authorInfo: any; reviewerInfo?: any}) => (
    <MUIBox className="bdn-author-bar">
        {/* Author */}
        <MUIBox className="bdn-author-info">
            <MUIAvatar src={authorInfo.image} alt={authorInfo.name || 'Author'} className="bdn-author-avatar" />
            <MUIBox>
                <MUITypography className="bdn-author-name bdn-person-name">{authorInfo.name || '—'} / Author</MUITypography>
                <MUITypography className="bdn-author-role bdn-person-role">{authorInfo.designation}</MUITypography>
            </MUIBox>
        </MUIBox>

        {/* Reviewed by — only renders when backend sends `reviewer_info` */}
        {reviewerInfo && (
            <MUIBox className="bdn-reviewed-by">
                <MUIBox className="bdn-reviewer-right">
                    <MUIBox>
                        <MUITypography className="bdn-reviewer-name bdn-person-name">{reviewerInfo.name ?? ''} / Reviewer</MUITypography>
                        <MUITypography className="bdn-reviewer-title bdn-person-role">{reviewerInfo.designation ?? ''}</MUITypography>
                    </MUIBox>
                    <MUIAvatar src={reviewerInfo.image ?? ''} alt={reviewerInfo.name ?? 'Reviewer'} className="bdn-reviewer-avatar" />
                </MUIBox>
            </MUIBox>
        )}

        {/* Google CTA */}
        <GoogleSourceCta />
    </MUIBox>
);

export default BlogAuthorBar;
